/* eslint-disabled */

export default class CampaignExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
